import { BenefitAllocation } from '@/types/benefit-allocation/benefit-allocation';
import { DownloadOutlined } from '@ant-design/icons';
import CustomButton from '@/components/custom-button/custom-button';
import { useState } from 'react';
interface DownloadBenefitProps {
	benefit: BenefitAllocation;
}

export const DownloadBenefit: React.FC<DownloadBenefitProps> = ({ benefit }) => {
	const [error, setError] = useState<string>('');
	const handleDownload = () => {
		const downloadLink = benefit?.reward_inventory?.metadata.download_link;
		
		if (!downloadLink) {
			setError('No se encontró el enlace de descarga');
			return;
		}
		setError('');
		const link = document.createElement('a');
		link.href = downloadLink;
		link.target = '_blank';
		link.download = '';
		
		document.body.appendChild(link);
		link.click();
		document.body.removeChild(link);
	};

	return (
		<>
				<CustomButton onClick={handleDownload}>
					¡Descarga tu cupón!
					<DownloadOutlined />
				</CustomButton>
				{error && <p style={{ color: 'red' }}>{error}</p>}
		</>
	);
};  